export default __webpack_public_path__ + "static/nebula-bc476212972c4fff0cf6d659b52b098e.webp";